import { Box, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import headerVideo from './../../../assets/about/header.mp4';
import { useTheme } from '@emotion/react';
// import { useLocation } from 'react-router-dom';
// import i18next from 'i18next';

const Header1 = ({ page_name }) => {
    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    // const location = useLocation();
    // let page = location.pathname.split('/')[1];
    // let lng = i18next.language;

    return (
        <Box
            sx={{
                position: 'relative',
                height: { md: '25rem', xs: '15rem' },
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // إضافة لضمان إزالة أي حدود من العنصر الأم
                border: 'none',
                outline: 'none',
                clipPath: 'fill-box',
                borderRadius: '0.01px'
            }}>
            <video
                className='video'
                src={headerVideo}
                autoPlay
                muted
                loop
                playsInline
                controlsList='nodownload nofullscreen noremoteplayback'
                controls={false}
                tabIndex="-1"
            />

            {/* النص */}
            <Box
                sx={{
                    // position: 'relative',
                    zIndex: 3,
                    textAlign: 'center',
                    position: 'absolute'
                }}
                color={'primary.bold'}>
                <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ textTransform: 'capitalize' }}>
                    {` ${page_name || ''}`}
                </Typography>
            </Box>
        </Box>
    );
};

export default Header1;
